import {ChangeDetectionStrategy, Component, DestroyRef, effect, Injectable, Injector, input, OnInit, runInInjectionContext, signal, Signal} from "@angular/core";
import {AgendaelementId, AvstemningMedResultatModell, AvstemningsstatusModell, MøteId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {Observable, switchMap} from "rxjs";
import {takeUntilDestroyed, toObservable, toSignal} from "@angular/core/rxjs-interop";
import {AvstemningListevisningKomponent} from "../../../avstemning/komponenter/avstemning-listevisning/avstemning-listevisning";
import {AvstemningDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningDatatjeneste";
import {tomAvstemningsstatusModell} from "felles-ng2/modell/tommeModeller";
import {erIkkeNil, erNil} from "felles-ng2/støttefunksjoner/nilsjekk";
import {AvstemningsstatusDatatjeneste} from "felles-ng2/tjenester/datalager/AvstemningsstatusDatatjeneste";

const debug = initDebugger('SakListeAvstemningerKomponent');

/**
 * Lister avstemninger knyttet til sak
 */
@Component({
    selector: 'sak-liste-avstemninger',
    templateUrl: 'sak-liste-avstemninger.html',
    styleUrl: 'sak-liste-avstemninger.scss',
    imports: [
        AvstemningListevisningKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SakListeAvstemningerKomponent implements OnInit {

    sakId = input.required<AgendaelementId>();
    moeteId = input.required<AgendaelementId>();
    moeteLaastForRedigering = input.required<boolean>();
    /** Avstemningstatus, lastes fra server dersom ikke angitt */
    angittAvstemningsstatus = input<AvstemningsstatusModell | null>(null, {alias: 'avstemningsstatus'});

    avstemninger: Signal<AvstemningMedResultatModell[]>;
    avstemningsstatus = signal<AvstemningsstatusModell>(tomAvstemningsstatusModell());

    constructor(private avhengigheter: SakListeAvstemningerKomponentAvhengigheter, private injector: Injector) {
        this.avstemninger = toSignal(toObservable(this.sakId)
            .pipe(switchMap(id => this.avhengigheter.avstemninger(id))),
          {initialValue: []});
    }

    ngOnInit(): void {
        runInInjectionContext(this.injector, ()=>{
            //i ngOnInit da angittAvstemningsstatus nå vil være satt dersom kaller har angitt dette attributtet
            //dersom angittAvstemningsstatus er angitt bruker vi denne
            effect(() => {
                if (erIkkeNil(this.angittAvstemningsstatus()))
                    this.avstemningsstatus.set(this.angittAvstemningsstatus()!);
            });
            //ellers henter vi avstemningsstatus fra server
            if (erNil(this.angittAvstemningsstatus())) {
                toObservable(this.moeteId).pipe(
                  switchMap(id => this.avhengigheter.avstemningsstatus(id)),
                  takeUntilDestroyed()
                ).subscribe(status  => this.avstemningsstatus.set(status));
            }
        });
    }
}

@Injectable()
export class SakListeAvstemningerKomponentAvhengigheter {

    constructor(private avstemningDatatjeneste: AvstemningDatatjeneste, private avstemningsstatusDatatjeneste:AvstemningsstatusDatatjeneste) {
    }

    avstemninger(id: AgendaelementId): Observable<AvstemningMedResultatModell[]> {
        return this.avstemningDatatjeneste.finnTilknyttetSakFraLokallager(id);
    }

    avstemningsstatus(møteId: MøteId): Observable<AvstemningsstatusModell> {
        return this.avstemningsstatusDatatjeneste.hent(møteId);
    }
}
